<script lang="ts">
export default {
    name: 'InscriptionButtons',
    props: {
        currentStep: { type: Number, required: true },
        maxStep: { type: Number, required: true },
        loading: { type: Boolean, required: false },
        disableNextButton: { type: Boolean, required: false },
        disableSaveButton: { type: Boolean, required: false },
    },
    emits: ['updateStep', 'save'],
}
</script>

<template>
    <v-row class="mt-4">
        <v-col v-if="currentStep > 1" cols="12" sm="6" class="py-0 mb-2">
            <v-btn
                color="primary"
                variant="outlined"
                block
                @click="$emit('updateStep', currentStep - 1)"
            >
                Précédent
            </v-btn>
        </v-col>
        <v-col cols="12" :sm="currentStep > 1 ? 6 : 12" class="text-right py-0 mb-2">
            <v-btn
                v-if="currentStep === maxStep"
                :disabled="disableSaveButton || disableNextButton"
                variant="flat" block color="primary"
                :loading="loading"
                @click.prevent="$emit('save')"
            >
                Créer le compte
            </v-btn>
            <v-btn
                v-else
                class="mb-2"
                variant="flat" block color="primary"
                :disabled="disableNextButton"
                @click="$emit('updateStep', currentStep + 1)"
            >
                Suivant
            </v-btn>
        </v-col>
    </v-row>
</template>
